// extracted by mini-css-extract-plugin
module.exports = {"main":"button-panel_main__3AAi0","btns":"button-panel_btns__2P1LN"};